<template>
<div>

  <van-nav-bar title="我的订阅" fixed="fixed">
    <template #left>
      <div @click="$back(this)" class="backButton">
        <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
      </div>
    </template>
  </van-nav-bar>

  <div style="padding-top: 46px">

    <div>
      <van-empty description="暂无订阅"/>
    </div>
  </div>


</div>
</template>

<script>
export default {
  name: "subscribe",
  methods:{
    get(){
      let member_uuid = localStorage.getItem('member_uuid')
      let api_token = localStorage.getItem('api_token')
      let query = this.$encrypt(this.$genQuery({member_uuid,api_token}))
      this.$get(this.$store.state.apiUrl + '/products/memberproducts',{qdata:query}).then(res=>{

      }).catch(err=>{
        console.log(err)
      })
    },

  },
  mounted() {
    if (!this.$store.state.SignedIn){
      this.$back(this)
    }
  }
}
</script>

<style scoped>

</style>
